<div class="button-toggle-group">
  <ng-content select="fm-button-toggle">
  </ng-content>
</div>
